import { useParams, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import trackingService from '../services/trackingService';

const CourseRedirector = () => {
  const { rawCourseId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!rawCourseId) {
      navigate('/');
      return;
    }

    // Parse courseId parameter in format: "11-cou-flg" (courseId-influencerId-flags)
    const parts = rawCourseId.split('-');
    const courseId = parts[0] || '1';
    const influencerId = parts[1] || '';
    const flags = parts[2] || '';

    // Set influencer if provided
    if (influencerId) {
      trackingService.setInfluencer(influencerId);
      trackingService.track('course_redirect_visit', {
        courseId,
        influencerId,
        flags
      });
    }
    let url;
    if (courseId === '1')
      url = '/beginner-track';
    else if (courseId === '2')
      url = '/experienced-track';
    else if (courseId === '3')
      url = '/ai-mastery';
    else
      url = `/course/${courseId}`;

    // Redirect to course landing page
    navigate(url);
  }, [rawCourseId, navigate]);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: '#f5f5f5'
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{
          animation: 'spin 1s linear infinite',
          border: '4px solid #f3f3f3',
          borderTop: '4px solid #3498db',
          borderRadius: '50%',
          width: '50px',
          height: '50px',
          margin: '0 auto 20px'
        }}></div>
        <p style={{
          color: '#666',
          fontSize: '16px',
          margin: 0
        }}>
          Taking you to your course...
        </p>
        <p style={{
          color: '#999',
          fontSize: '12px',
          margin: '10px 0 0 0'
        }}>
          One moment please
        </p>
      </div>

      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default CourseRedirector;